'use client';

import { Container } from '@/layers/presentation/components/common/Container';
import PageHero from '@/layers/presentation/components/common/PageHero';
import LandingLayout from '@/layers/presentation/layouts/LandingLayout';
import Link from 'next/link';

export default function NotFound() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Not Found', href: '#' },
  ];

  return (
    <LandingLayout>
      <>
        <PageHero
          title="Page Not Found"
          breadcrumbs={breadcrumbs}
          backgroundImage="/images/hero-gradient.jpg"
        />
        <Container>
          <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
            <h2 className="!pb-0 mb-4 text-xl sm:text-2xl md:text-3xl leading-normal">
              We couldn&apos;t find the page you&apos;re looking for
            </h2>
            <p className="text-default-700 mb-8 max-w-2xl">
              The page you requested could not be found. It might have been removed, renamed, or did
              not exist in the first place.
            </p>
            <Link href="/" className="rh-btn-black-lg">
              Return to Home
            </Link>
          </div>
        </Container>
      </>
    </LandingLayout>
  );
}
